import { makeStyles } from "@material-ui/core";

export const participantFAQStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    background: "transparent",
    alignSelf: "center",
    justifySelf: "center",
  },
  title: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(30),
  },
  subtitle: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(22),
    padding: "10px 0",
  },
  questionContainer: {
    margin: 0,
    padding: 0,
  },
  question: {
    padding: `${theme.typography.pxToRem(10)} 0px`,
    fontFamily: "Lato",
    fontSize: 20,
  },
  questionNumber: {
    marginRight: theme.typography.pxToRem(20),
    fontSize: theme.typography.pxToRem(16),
    fontFamily: "Lato",
    color: "#00A3A3",
  },
  answer: {
    paddingLeft: theme.spacing(6),
    fontSize: theme.typography.pxToRem(16),
    fontFamily: "Lato",
  },
  contact: {
    marginTop: theme.typography.pxToRem(60),
  },
  contactMessage: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 600,
    color: "black",
    marginBottom: theme.spacing(4),
  },
  buttonContact: {
    color: "white",
    background: "#0344DC",
    borderRadius: "100px",
    padding: "12px 24px",
    margin: "0 10px",
    textAlign: "center",
    textDecoration: "none",
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(16),
    gap: "8px",
    "&:hover": {
      color: "white",
      background: "#0344DC",
    },
  },
  accordion: {
    background: "transparent",
    boxShadow: "none",
    border: "none",
    borderTop: "1px solid lightgrey",
    borderBottom: "1px solid lightgrey",
    margin: 0,
  },
  arrowIcon: {
    color: "#F15A28",
  },
  textWrap: {
    wordBreak: "break-word",
  },
}));
